// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

// Added function to display pfand Price when cart updated event call
function formatMoney$1(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

var formatMoney = (val) => formatMoney$1(val, window.theme.moneyFormat || "${{amount}}");

document.addEventListener("cart:item-added", function (evt) {
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  var items = evt.detail.cart.items;
  const item = items.filter((product) => product.properties.hasOwnProperty("__mainProductId"));
  //  Add OR Remove Pfand price when cart is updated.
  if (item.length > 0) {
    const targetEle = document.querySelector(".quick-cart__footer");
    const totalOriginalLinePrice = item.reduce(
      (sum, product) => sum + product.original_line_price,
      0
    );
    let pfandDiv = targetEle.querySelector(".pfand-total");
    if (!pfandDiv) {
      const newDiv = document.createElement("div");
      newDiv.className = "cart__total_wrapper pfand-total";
      newDiv.innerHTML = `
                    <span>Pfand</span>
                    <span class="fs-body-bold deposit-text">${formatMoney(totalOriginalLinePrice)}</span>
                `;
      const firstTotalWrapper = targetEle.querySelector(".cart__total_wrapper");
      if (firstTotalWrapper) {
        firstTotalWrapper.insertAdjacentElement("afterend", newDiv);
      } else {
        targetEle.appendChild(newDiv);
      }
    } else {
      const priceSpan = pfandDiv.querySelector(".deposit-text");
      if (priceSpan) {
        priceSpan.textContent = formatMoney(totalOriginalLinePrice);
      }
    }
  } else {
    const pfandDiv = document.querySelector(".pfand-total");
    if (pfandDiv) {
      pfandDiv.remove();
    }
  }
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  document.body.classList.add("overflow-hidden");
  // Add Pfand price create div in case if Deposit Product exists when cart open
  const items = evt.detail.cart.items;

  const filteredProducts = items.filter((product) =>
    product.properties.hasOwnProperty("__mainProductId")
  );

  if (filteredProducts.length > 0) {
    const totalOriginalLinePrice = filteredProducts.reduce(
      (sum, product) => sum + product.original_line_price,
      0
    );
    const targetEle = document.querySelector(".quick-cart__footer");
    let pfandDiv = targetEle.querySelector(".pfand-total");
    if (!pfandDiv) {
      const newDiv = document.createElement("div");
      newDiv.className = "cart__total_wrapper pfand-total";
      newDiv.innerHTML = `
                    <span>Pfand</span>
                    <span class="fs-body-bold deposit-text">${formatMoney(totalOriginalLinePrice)}</span>
                `;
      const firstTotalWrapper = targetEle.querySelector(".cart__total_wrapper");
      if (firstTotalWrapper) {
        firstTotalWrapper.insertAdjacentElement("afterend", newDiv);
      } else {
        targetEle.appendChild(newDiv);
      }
    } else {
      const priceSpan = pfandDiv.querySelector(".deposit-text");
      if (priceSpan) {
        priceSpan.textContent = formatMoney(totalOriginalLinePrice);
      }
    }
  }
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  document.body.classList.remove("overflow-hidden");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  updateSkalaOnVariantChange(evt.detail.variant);
  updateVariantStockBadge(evt.detail.variant);
  updateVariantBox(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when a 'Enable hover add-to-cart' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// This event fires whenever after additional collection items are
// added to the page due to filtering or click to load / infinite loading.
document.addEventListener("products:loaded", function () {
  console.log("Products loaded");
});

// BD feat start
function updateVariantBox(currentVariant) {
  const variantImgEl = document.querySelector("[js-selected-variant-image] [js-image]");
  const variantExtraInfoJson =
    document.querySelector("[data-pi-variants-json]") &&
    JSON.parse(document.querySelector("[data-pi-variants-json]")?.textContent);
  const variantsJson = JSON.parse(document.querySelector("[data-variant-json]").textContent);
  const defaultOptions = document.querySelectorAll("[js-default-option]");
  const customButtonOptions = document.querySelectorAll("[js-variant-box]");
  const customSelectOptions = document.querySelectorAll("[js-fayn-custom-option]");

  // Load variant stock badges for pseudo out-of-stock check
  const variantStockJsonElement = document.getElementById("variantStockJson");
  const variantStockData = variantStockJsonElement ? JSON.parse(variantStockJsonElement.textContent).variantStock : {};

  const customSelect = document.querySelector("[dynamic-variant-input]");
  const selectOptionValue = customSelect?.value;
  const selectPosition = customSelect?.getAttribute("data-index");

  customButtonOptions.forEach((box) => {
    updateCustomButtomOptionsImage(box, currentVariant, variantsJson);

    const BtnPosition = parseInt(box.getAttribute("data-option-position"));
    const BtnOptionValue = box.getAttribute("data-option-value");

    if (selectPosition && selectOptionValue) {
      variantsJson.forEach((variant) => {
        // Check both the label's attribute and the dynamic variantStockData
        const hasStockBadge = box.getAttribute("data-variant-stock-badge") || variantStockData[variant.id];

        if (
          variant.available &&
          !hasStockBadge &&
          BtnOptionValue === variant[`option${BtnPosition}`] &&
          selectOptionValue === variant[selectPosition]
        ) {
          box.classList.remove("is-hidden");
        }

        if (
          (!variant.available || hasStockBadge) &&
          BtnOptionValue === variant[`option${BtnPosition}`] &&
          selectOptionValue === variant[selectPosition]
        ) {
          box.classList.add("is-hidden");
        }
      });
    } else {
      variantsJson.forEach((variant) => {
        // Check for pseudo out-of-stock in addition to regular out-of-stock
        const hasStockBadge = variantStockData[variant.id];
        
        if (
          variant.available &&
          !hasStockBadge &&
          BtnOptionValue === variant[`option${BtnPosition}`] &&
          variant.id == currentVariant.id
        ) {
          box.classList.remove("is-hidden");
          console.log("fdkfldkfldfdff");
        }

        if (
          (!variant.available || hasStockBadge) &&
          BtnOptionValue === variant[`option${BtnPosition}`] &&
          variant.id == currentVariant.id
        ) {
          box.classList.add("is-hidden");
          console.log("003033");
        }
      });
    }
  });

  customVariantHideFunction(
    variantExtraInfoJson,
    currentVariant,
    customButtonOptions,
    customSelectOptions,
    defaultOptions,
    variantsJson
  );

  if (variantImgEl) {
    const featured_image = currentVariant.featured_image?.src?.replace(
      /(\.[a-zA-Z0-9]+)(\?.*)?$/,
      `_150x$1$2`
    );
    variantImgEl.setAttribute("src", featured_image || currentVariant.featured_image.src);
    variantImgEl.setAttribute("srcset", featured_image || currentVariant.featured_image.src);
    variantImgEl.setAttribute("data-srcset", featured_image || currentVariant.featured_image.src);
  }
}

function updateVariantStockBadge(currentVariant) {
  const vid = currentVariant.id;
  const variantStockJsonElement = document.getElementById("variantStockJson");
  if (variantStockJsonElement) {
    try {
      const variantStockData = JSON.parse(variantStockJsonElement.textContent);
      const variantStockText = variantStockData.variantStock[vid];

      const badgeElement = document.querySelector("[data-variant-stock-badge]");
      const submitButton = document.querySelector(".product-form__cart-submit");
      const addToCartTextElement = submitButton
        ? submitButton.querySelector("[data-add-to-cart-text]")
        : null;

      if (badgeElement) {
        if (variantStockText) {
          badgeElement.textContent = variantStockText;
          badgeElement.removeAttribute("hidden");
        } else {
          badgeElement.setAttribute("hidden", "");
        }
      }
      if (submitButton) {
        if (variantStockText) {
          if (addToCartTextElement) {
            submitButton.setAttribute("disabled", "disabled");
            addToCartTextElement.textContent = variantStockText;
          }
        }
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  } else {
    console.error("Element with ID 'variantStockJson' not found");
  }

  const selectedMediaImageWrappers = document.querySelectorAll("[js-featured-image-wrapper]");
  selectedMediaImageWrappers.forEach((selectedMediaImageWrapper) => {
    const featuredImage = selectedMediaImageWrapper.querySelector("img");
    if (featuredImage) {
      featuredImage.src = currentVariant.featured_image.src;
      featuredImage.srcset = currentVariant.featured_image.src;
      if (typeof mainPDPSlider != "undefined") {
        mainPDPSlider?.select(0);
      }
    }
  });
}

// ▶ NEW: Run both checks on initial page load ◀
document.addEventListener("DOMContentLoaded", function () {
  // we assume you’re exposing your initial variant here
  const initial = window.specificConditionCurrentVariantData;
  if (initial) {
    updateVariantBox(initial);
    updateVariantStockBadge(initial);
  }
});

// ▶ (optional) also keep your existing change-listener so selects still re-run them ◀
document.addEventListener("change", function (evt) {
  if (!evt.target.matches("[dynamic-variant-input]")) return;
  const vid = parseInt(evt.target.value, 10);
  const variantsJson = JSON.parse(document.querySelector("[data-variant-json]").textContent);
  const next = variantsJson.find((v) => v.id === vid);
  if (next) {
    updateVariantBox(next);
    updateVariantStockBadge(next);
  }
});
// BD feat end

const skalaMaxHeight = document.querySelector("[js-hb-skala-wrap]");
if (skalaMaxHeight) {
  const skalaStoreHeight = skalaMaxHeight.scrollHeight;
  skalaMaxHeight.style.height = skalaStoreHeight + "px";
}

async function updateSkalaOnVariantChange({ id }) {
  const url = `${location.origin}${location.pathname}?variant=${id}&view=skalaAjax`;
  const response = await fetch(url);
  const html = await response.text();
  const ajaxDom = new DOMParser().parseFromString(html, "text/html");
  const ajaxSkalaWrapper = ajaxDom.querySelector("[js-hb-skala-wrapper]");

  if (ajaxSkalaWrapper && document.querySelector("[js-hb-skala-wrapper]")) {
    document.querySelector("[js-hb-skala-wrapper]").replaceWith(ajaxSkalaWrapper);
  }

  if (ajaxSkalaWrapper.querySelector(".hb_kaffee-intensitat__label")) {
    const skalaStoreHeight = skalaMaxHeight.scrollHeight;
    skalaMaxHeight.style.height = skalaStoreHeight + "px";
  } else {
    skalaMaxHeight.style.height = "0px";
  }

  if (
    document.querySelector("[js-inventory-message-wrapper]") &&
    ajaxDom.querySelector("[js-inventory-message-wrapper]")
  ) {
    document
      .querySelector("[js-inventory-message-wrapper]")
      .replaceWith(ajaxDom.querySelector("[js-inventory-message-wrapper]"));
  }
}

function updateCustomButtomOptionsImage(currentTag, currentVariant, variantsJson) {
  const imgEl = currentTag.querySelector("[js-image]");
  let currentVariantBaseOptionTag = getVariantBaseOnCurrentVariantAndCurrentAttribute(
    currentTag,
    currentVariant,
    variantsJson
  );

  const priceTag = currentTag.querySelector("[js-variant-price]");

  if (priceTag) {
    priceTag.innerHTML = `${theme?.moneyFormat?.split("}}")[1]}${(currentVariantBaseOptionTag.price / 100).toFixed(2)}`;
  }

  const featured_image = currentVariantBaseOptionTag?.featured_image?.src?.replace(
    /(\.[a-zA-Z0-9]+)(\?.*)?$/,
    `_150x$1$2`
  );

  if (imgEl && featured_image) {
    imgEl.setAttribute("src", featured_image || currentVariantBaseOptionTag.featured_image.src);
    imgEl.setAttribute("srcset", featured_image || currentVariantBaseOptionTag.featured_image.src);
    imgEl.setAttribute(
      "data-srcset",
      featured_image || currentVariantBaseOptionTag.featured_image.src
    );
  }
}

document.addEventListener("updateCustomButtomOptionsImage:init", ({ detail }) => {
  const { currentTag, currentVariant, variantsJson } = detail;
  updateCustomButtomOptionsImage(currentTag, currentVariant, variantsJson);
});

function customVariantHideFunction(
  variantExtraInfoJson,
  currentVariant,
  customButtonOptions,
  customSelectOptions,
  defaultOptions,
  variantsJson
) {
  enableOrDisableHideClassForOptions(
    customButtonOptions,
    currentVariant,
    variantExtraInfoJson,
    variantsJson
  );
  enableOrDisableHideClassForOptions(
    customSelectOptions,
    currentVariant,
    variantExtraInfoJson,
    variantsJson
  );
  enableOrDisableHideClassForOptions(
    defaultOptions,
    currentVariant,
    variantExtraInfoJson,
    variantsJson
  );

  if (window.addDisabledClassOnLoad) {
    window.addDisabledClassOnLoad(currentVariant);
  }
}

function enableOrDisableHideClassForOptions(
  options,
  currentVariant,
  variantExtraInfoJson,
  variantsJson
) {
  options.forEach((optionTag) => {
    let currentVariantBaseOptionTag = getVariantBaseOnCurrentVariantAndCurrentAttribute(
      optionTag,
      currentVariant,
      variantsJson
    );

    if (currentVariantBaseOptionTag) {
      variantExtraInfoJson?.forEach((variant) => {
        if (currentVariantBaseOptionTag.id === variant.id) {
          if (variant.purchasable == false) {
            optionTag.classList.add("hide");
          } else {
            optionTag.classList.remove("hide");
          }
        }
      });
    }
  });
}

function getVariantBaseOnCurrentVariantAndCurrentAttribute(
  optionTag,
  currentVariant,
  variantsJson
) {
  const optionPostion = parseInt(optionTag.getAttribute("data-option-position"));
  const optionValue = optionTag.getAttribute("data-option-value");
  let currentVariantBaseBoxValue;
  currentVariantBaseBoxValue = variantsJson.find((variant) => {
    let variantTitle;
    switch (optionPostion) {
      case 1:
        variantTitle = `${optionValue}`;
        if (currentVariant.option2) {
          variantTitle += ` / ${currentVariant.option2}`;
        }
        if (currentVariant.option3) {
          variantTitle += ` / ${currentVariant.option3}`;
        }
        break;
      case 2:
        if (currentVariant.option1) {
          variantTitle = `${currentVariant.option1}`;
        }
        variantTitle += ` / ${optionValue}`;
        if (currentVariant.option3) {
          variantTitle += ` / ${currentVariant.option3}`;
        }
        break;
      case 3:
        if (currentVariant.option1) {
          variantTitle = `${currentVariant.option1}`;
        }
        if (currentVariant.option2) {
          variantTitle += ` / ${currentVariant.option2}`;
        }
        variantTitle += ` / ${optionValue}`;
        break;
    }
    return variant.title.includes(variantTitle);
  });
  return currentVariantBaseBoxValue;
}

document.addEventListener("customVariantHideFunction:init", ({ detail }) => {
  const {
    variantExtraInfoJson,
    currentVariant,
    customButtonOptions,
    customSelectOptions,
    defaultOptions,
    variantsJson,
  } = detail;
  customVariantHideFunction(
    variantExtraInfoJson,
    currentVariant,
    customButtonOptions,
    customSelectOptions,
    defaultOptions,
    variantsJson
  );
});

if (window.specificConditionCurrentVariantData) {
  window.addDisabledClassOnLoad = function (currentVariant) {
    const variantsJson = JSON.parse(document.querySelector("[data-variant-json]").textContent);
    const customSelectOptions = document.querySelectorAll("[js-fayn-custom-option]");

    customSelectOptions.forEach((option) => {
      const position = parseInt(option.getAttribute("data-option-position"));
      const optionValue = option.getAttribute("data-option-value");

      variantsJson.forEach((variant) => {
        if (
          variant.available &&
          optionValue === variant[`option${position}`] &&
          variant.id == currentVariant.id
        ) {
          option.classList.remove("disabled");
        }

        if (
          variant.available === false &&
          optionValue === variant[`option${position}`] &&
          variant.id == currentVariant.id
        ) {
          option.classList.add("disabled");
        }
      });
    });
  };

  addDisabledClassOnLoad(window.specificConditionCurrentVariantData);
}

// BD feat end
